export enum OverlayTypes {
  SET_OVERLAY_ACTIVE = '@OVERLAY/SET_OVERLAY_ACTIVE'
}

export interface OverlayState {
  readonly isOverlayActive: boolean;
}
